import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardPage } from '../../components/DashboardPage';
import Button from '../../components/Buttons/Button';
import { HeaderList } from '../../components/HeaderList';
import { ContentOrLoading } from '../../components/Loadings/ContentOrLoading';
import { useApi } from '../../hooks/api';
import { useGlobal } from '../../hooks/global';
import { inactiveItens } from '../../theme';
import { featureGuides } from '../../utils/featureGuides';
import { Column, Line } from '../../style';
import { GuideCard, GuideDescription, GuidesGrid, GuideTitle } from './style';
import { FeedbackModal } from './FeedbackModal';
import { FeatureGuide } from '../../utils/featureGuides';

export const Guides: React.FC = () => {
  const { api, user } = useApi(); const { theme, notify, startFeatureGuide, isMobile } = useGlobal(); const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [feedbackGuide, setFeedbackGuide] = useState<FeatureGuide | null>(null);
  const servicesRef = useRef({ api, notify });
  servicesRef.current = { api, notify };
  const load = useCallback(async () => {
    setLoading(true);
    try { await servicesRef.current.api.get('/feature-guides'); }
    catch { servicesRef.current.notify('Não foi possível carregar os guias.', 'error'); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => {
    if (isMobile) navigate('/', { replace: true });
  }, [isMobile, navigate]);
  useEffect(() => {
    if (!isMobile) load();
  }, [isMobile, load]);
  const reopen = async (code: string, path: string) => { try { await api.post(`/feature-guides/${code}/reopen`); startFeatureGuide(code); window.dispatchEvent(new Event('feature-guides-updated')); navigate(`${path}?guide=${code}`); } catch { notify('Não foi possível abrir este guia.', 'error'); } };
  if (isMobile) return null;
  return <DashboardPage><Column style={{ gap: 20, flex: 1, color: inactiveItens[theme] }}>
    <HeaderList textHeader="Guias" textDescritpion="Orientações rápidas para aproveitar as novidades da Max Locação" theme={theme} haveBorder loading={loading} onRefresh={load} />
    <ContentOrLoading loading={loading} text="Buscando guias" theme={theme}>
    <GuidesGrid>{featureGuides.map(guide => {
      return <GuideCard key={guide.code} theme={theme}>
        <div><GuideTitle>{guide.title}</GuideTitle><GuideDescription>{guide.description}</GuideDescription></div>
        <Line style={{ justifyContent: 'center', alignItems: 'center' }}><Button onClick={() => user.type === 'root' ? setFeedbackGuide(guide) : reopen(guide.code, guide.path)} style={{ minWidth: 150, minHeight: 41.5, justifyContent: 'center', alignItems: 'center' }} background={inactiveItens[theme]} color="#FFF" children={user.type === 'root' ? 'Ver feedbacks' : 'Ver guia'} /></Line>
      </GuideCard>;
    })}</GuidesGrid>
    </ContentOrLoading>
    {feedbackGuide && <FeedbackModal guide={feedbackGuide} onClose={() => setFeedbackGuide(null)} />}
  </Column></DashboardPage>;
};
